// =============================================================================
// Lucide Icons Integration
// =============================================================================

import { createIcons, icons } from "lucide";

/**
 * Initialize Lucide icons on elements with data-icon attribute.
 * Use any Lucide icon name directly: https://lucide.dev/icons
 *
 * Usage: <i data-icon="Users"></i>
 *        <i data-icon="MapPin"></i>
 *        <i data-icon="TrendingUp"></i>
 */
export function initIcons(): void {
    // Convert data-icon to data-lucide for Lucide's createIcons
    const iconElements = document.querySelectorAll<HTMLElement>("[data-icon]");

    iconElements.forEach((el) => {
        const iconName = el.dataset.icon;
        if (!iconName) return;

        // Set the data-lucide attribute directly with the icon name
        el.setAttribute("data-lucide", iconName);
    });

    // Create all Lucide icons
    createIcons({
        icons,
        attrs: {
            "stroke-width": 2,
        },
    });
}
